import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { pluralize } from "utils/pluralize";

type BulkDeleteProductsModalProps = {
  open: boolean;
  count: number;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const BulkDeleteProductsModal = ({
  open,
  count,
  isLoading,
  onCancel,
  onConfirm,
}: BulkDeleteProductsModalProps) => {
  return (
    <Modal.Root open={open} onOpenChange={onCancel}>
      <Modal.Content size="small">
        <StatusModal
          type="danger"
          title={`Delete ${pluralize(count, "item", "items")}?`}
        >
          The selected products and services will be permanently deleted. This
          action cannot be undone.
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Button type="button" onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="button"
            customType="danger"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Delete
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
